import { CSSProperties, FC, ReactNode, createElement } from 'react';
import classNames from 'classnames';
import classes from './Typography.module.scss';

enum TypographyVariant {
  h1_semibold = 'h1_semibold',
  h1_semibold_client = 'h1_semibold_client',

  h2_semibold = 'h2_semibold',
  h2_bold = 'h2_bold',
  h2_semibold_client = 'h2_semibold_client',

  h3_semibold_client = 'h3_semibold_client',

  h4_regular = 'h4_regular',
  h4_medium = 'h4_medium',

  text_secondary_regular = 'text_secondary_regular'
}

export type TypographyProps = {
  children: ReactNode;
  variant: TypographyVariant;
  className?: string;
  tagName?: string;
  style?: CSSProperties;
  onClick?: () => void;
};

const Typography: FC<TypographyProps> = ({
  children,
  variant,
  tagName = 'div',
  className = '',
  style,
  onClick
}) => {
  const currentClasses = classNames(classes.dimensions, classes[`${variant}`], {
    [className]: className
  });

  return createElement(tagName, { className: currentClasses, style, onClick }, children);
};

export { TypographyVariant };
export default Typography;
